/* yl-reveal.js — scroll-in reveal for the emerald layer.
 * Elements with .yle-reveal (plus auto-tagged section heads and product cards)
 * get .is-revealed when they enter the viewport; CSS in yololife-emerald.css
 * animates opacity/translate. The <head> inline guard removes html.yle-js if
 * this file has not run within 3s, so content can never stay hidden.
 */
(function () {
  'use strict';
  var root = document.documentElement;
  window.__yleRevealReady = true;
  if (!('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    root.classList.remove('yle-js');
    return;
  }

  var AUTO = '.yl-sec-head, .yle-head, .yl-species__grid > .yl-species-card, .yl-footer__grid';

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });

  function stagger(el) {
    var grid = el.parentElement;
    if (!grid || !grid.classList.contains('yl-species__grid')) return;
    var index = Array.prototype.indexOf.call(grid.children, el);
    el.style.setProperty('--yle-reveal-delay', (index % 4) * 70 + 'ms');
  }

  function watch(scope) {
    var nodes = [];
    if (scope.matches && (scope.matches('.yle-reveal') || scope.matches(AUTO))) nodes.push(scope);
    if (scope.querySelectorAll) {
      nodes = nodes.concat(Array.prototype.slice.call(scope.querySelectorAll('.yle-reveal, ' + AUTO)));
    }
    nodes.forEach(function (el) {
      if (el.dataset.yleReveal) return;
      el.dataset.yleReveal = '1';
      el.classList.add('yle-reveal');
      stagger(el);
      io.observe(el);
    });
  }

  function start() {
    watch(document.body);
    // Cards appended by infinite scroll / re-rendered sections.
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) watch(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
